export const userStateKey = 'user';
export const merchantStoreKey = 'merchantStore';
export const mfaSettingsStateKey = 'mfaSettings';
